<template>
  <div class="paginations">
    <!-- <el-button size="mini" :disabled="currentPage === 1" @click="goFirstPage">
      首页
    </el-button> -->
    <el-pagination
      @size-change="$emit('size-change', $event)"
      @current-change="handleCurrentChange"
      :current-page="innerCurrentPage"
      :page-size="size"
      :total="total"
      layout="prev, pager, next, jumper"
    />
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 100,
    },
    size: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return { innerCurrentPage: this.currentPage };
  },
  watch: {
    // 监听父组件 currentPage 变化，同步到内部
    currentPage(newVal) {
      this.innerCurrentPage = newVal;
    },
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(newPage) {
      this.innerCurrentPage = newPage;
      this.$emit('update:current-page', newPage); // 通知父组件更新 .sync 绑定的值
      this.$emit('current-change', newPage); // 触发自定义事件
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.paginations {
  display: flex;
  justify-content: flex-end;
  width: 62.5%;
  margin: 0 auto;

  padding: 2rem 0 2.75rem;
}
::v-deep {
  // .el-breadcrumb__item:last-child {
  //   .el-breadcrumb__inner {
  //     color: #a89d69;
  //   }
  // }

  // .el-breadcrumb__item {
  //   cursor: pointer;
  // }

  // .btn-prev,
  // .btn-next {
  //   background: #fff !important;
  //   color: #666 !important;
  //   padding: 0 10px !important;
  //   border: solid 1px #999;
  // }

  .number,
  .el-icon-more {
    color: #424451 !important;
    // border: 1px solid #459087 !important;
    background: #d9d9d9 !important;
    border-radius: 0.125rem;
    margin-right: 9px;
  }

  // .btn-quicknext {
  //   color: #459087 !important;
  //   border: 1px solid #999 !important;
  // }

  .active {
    background: #6b6d7a !important;
    color: #fff !important;
  }
}
</style>
